<template>
  <div class="project-wrapper">

    <div class="project-intro">
      <p class="project-actions">
        <a href="/assets/soprasolar/files/note_controle_reception_24.09.25.pdf" target="_blank" rel="noopener noreferrer" class="button-outline">
          {{ Translator('soprasolar.claim_request.intro.control_document_button') }}
        </a>

      </p>
      <h1 class="project-title">{{ Translator('soprasolar.claim_request.intro.title') }}</h1>
      <p class="project-description">
        <i class="ic ic-info" aria-hidden="true"></i>
        {{ Translator('soprasolar.claim_request.intro.description') }}
      </p>

      <div class="project-infos">
        <p class="project-infos-title">
          <i class="ic ic-info" aria-hidden="true"></i>
          {{ Translator('soprasolar.claim_request.intro.declaration_delay.title') }}
        </p>
        <div class="project-infos-content" v-html="Translator('soprasolar.claim_request.intro.declaration_delay.content')"></div>
      </div>

      <div class="project-infos">
        <p class="project-infos-title">
          <i class="ic ic-info" aria-hidden="true"></i>
          {{ Translator('soprasolar.claim_request.intro.declaration_control.title') }}
        </p>
        <div class="project-infos-content" v-html="Translator('soprasolar.claim_request.intro.declaration_control.content')"></div>
      </div>

      <p class="project-actions">
        <button type="button" class="button-flat" @click="onStart()">
          {{ Translator('soprasolar.claim_request.intro.start_button') }}
          <i class="ic ic-arrow-right"></i>
        </button>
      </p>
    </div>

  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-claim/assets/styles/import";
  .button-outline {
    @include cta( $color-main, $white, $color-main );
  }
  .project-intro {
    .project-title,
    .project-actions,
    .project-description {
      text-align: center;
    }
    .project-description {
      margin-bottom: rem(30);
      .ic {
        font-size: rem(18);
      }
    }
    .project-actions {
      padding-top: rem(30);
      padding-bottom: rem(50);
    }
  }
  .project-infos {
    background-color: $grey-ulight;
    margin-bottom: rem(20);
    border-radius: rem(8);
    padding: rem(20) rem(40);
    max-width: rem(720);
    margin-left: auto;
    margin-right: auto;
    .project-infos-title {
      position: relative;
      font-weight: bold;
      color: $color-main;
      margin-bottom: rem(10);
      .ic {
        position: absolute;
        left: rem(-10);
        top: 0;
        transform: translateX(-100%);
        font-size: rem(22);
      }
    }
    .project-infos-content {
      color: $grey;
      font-size: rem(14);
    }
  }
</style>
<script>
import AppControlService from '@/soprasolar-claim/services/AppControl';

export default {
  name: 'intro',
  components: {},
  data () {
    return {
      datas: AppControlService.datas
    }
  },

  created() {},

  beforeDestroy() {},

  mounted() {},

  methods: {
    onStart() {
      AppControlService.goToNextStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>